import React, { useState, useEffect, useRef } from 'react';
import '../style/chat.scss'

const ThreadTitle = ({ title, className, fontSize }: { title: string, className?: string, fontSize?: string }) => {
  const [shortTitle, setShortTitle] = useState(title);
  const titleRef = useRef<HTMLParagraphElement | null>(null); // Explicitly typing the ref

  useEffect(() => {
    if (titleRef.current) {
      const containerWidth = titleRef.current.offsetWidth; // Now TypeScript knows this exists

      const measureText = (text: string) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        if (!context) {
          return 0; // Return 0 if the context is null
        }

        context.font = '13px sans-serif'; // match your CSS font-size and font-family
        return context.measureText(text).width;
      };

      let truncatedTitle = title;
      if (measureText(title) > containerWidth) {
        let charsToShow = title.length;
        while (measureText(title.substring(0, charsToShow) + '...') > containerWidth && charsToShow > 0) {
          charsToShow--;
        }
        truncatedTitle = title.substring(0, charsToShow) + '...';
      }
      setShortTitle(truncatedTitle);
    }
  }, [title]);

  return (
    <p className={`${fontSize ? `font-size-${fontSize}` : 'font-size-13'} m-0 thread-title ${className}`} ref={titleRef}>
      {shortTitle}
    </p>
  );
};

export default ThreadTitle;
